import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=2322015a&scoped=true"
import script from "./CreateList.vue?vue&type=script&lang=js"
export * from "./CreateList.vue?vue&type=script&lang=js"
import style0 from "./CreateList.vue?vue&type=style&index=0&id=2322015a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322015a",
  null
  
)

export default component.exports